import {
  AccordionButton,
  AccordionItem,
  Badge,
  Box,
  Flex,
  Icon,
  Spinner,
  Text,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Button,
} from '@chakra-ui/react'
import React from 'react'
import { FaEye, FaEyeSlash, FaRegTrashAlt, FaRegNewspaper } from 'react-icons/fa'
import { IoIosArrowDown } from 'react-icons/io'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../services/api'
import { formatPrice } from '../../../utils/formatPrice'
import { CollapseItem } from './CollapseItem'
import { ExpandedItem } from './ExpandedItem'
import { memo } from 'react'
import { useParams } from 'react-router-dom'
import { useOrcamentoPedido } from '../../../contexts/OrcamentoPedidoProvider'

async function addItems({ item, numero_nota, codigo_parceiro, email_parceiro, telefone_parceiro, nome_parceiro, codigo_vendedor }) {
  const params = {
    numero_nota,
    codigo_parceiro,
    email_parceiro,
    telefone_parceiro,
    nome_parceiro,
    codigo_vendedor,

    produtos: [
      {
        codigo_produto: item.codigo_produto,
        quantidade: item.quantidade,
        valor_unitario: item.original_preco_venda,
        valor_total: item.original_valor_total_itens,
        valor_frete: 39,
        valor_total_frete: 39,
        prazo: item.prazo,
        id_impressao: item.id_personalizacao,
        qtd_batida: item.qtd_batida,
        codigo_cor: item.codigo_cor,
        frete_site: item.frete_site || 0,
        cubagem: {
          qtdcaixa: item.cubagem.qtdcaixa,
          caixa: item.cubagem.caixa,
          qtdporcaixa: item.cubagem.qtdporcaixa,
          cubagemunitaria: item.cubagem.cubagemunitaria,
          cubagemtotal: item.cubagem.cubagemtotal,
        },
      },
    ],
  }

  const response = await api.post('/site/v2/orcamento-crm/inserir-produtos-orcamento', params)

  return response.data
}

async function deleteItem({ item }) {
  const response = await api.delete(`/site/v2/orcamento-crm/excluir-produto-orcamento`, {
    data: {
      codigo_produto: item.codigo_produto,
      numero_nota: item.numero_nota,
      sequencia: item.sequencia,
    },
  })

  return response.data
}

const ItemComponent = ({
  item,
  isExpanded,
  onToggle,
  index,
  cliente,
  email_parceiro,
  telefone_parceiro,
  nome_parceiro,
  codigo_vendedor,
  nome_vendedor,
  num_proposta,
}) => {
  const [collapse, setCollapse] = React.useState(false)
  const { numeroProposta: numProposta } = useParams()
  const { pedidoBloqueado, solicitarCaricatura, solicitarCaricaturaLoading } = useOrcamentoPedido()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
    duration: 2000,
  })

  const queryClient = useQueryClient()

  const { mutateAsync: handleDuplicateItem, isLoading: duplicateLoading } = useMutation({
    mutationFn: () =>
      addItems({
        item,
        numero_nota: item.numero_nota,
        codigo_parceiro: cliente.codigo_parceiro,
        email_parceiro: email_parceiro,
        telefone_parceiro: telefone_parceiro,
        nome_parceiro: nome_parceiro,
        codigo_vendedor: codigo_vendedor,
      }),
    onSuccess: (data) => {
      queryClient.setQueryData(['items', numProposta], (old) => {
        return {
          ...old,
          informacao_da_proposta: {
            ...old.informacao_da_proposta,
            calc_kangu: data[0].calc_kangu,
            comissao_prevista: data[0].comissao_prevista,
          },
          itens: [
            ...old.itens,
            {
              ...data[0],
              codigo_cor: parseInt(data[0].codigo_cor),
              id_personalizacao: parseInt(data[0].id_personalizacao),
              qtd_batida: parseInt(data[0].qtd_batida),
              prazo: parseInt(data[0].prazo),
              id: `${item.codigo_produto}-${parseInt(Math.random() * new Date().getTime())}`,
              quantidade: String(data[0].quantidade),
              valor_total_itens: formatPrice(data[0].valor_total_itens),
              preco_base: formatPrice(data[0].preco_base),
              preco_site: formatPrice(data[0].preco_site),
              preco_venda: formatPrice(data[0].preco_venda),
              original_valor_total_itens: data[0].valor_total_itens,
              original_preco_venda: data[0].preco_venda,
              vlr_substituicao: formatPrice(data[0].vlr_substituicao),
              original_vlr_substituicao: data[0].vlr_substituicao,
              prazos: data[0].prazos.map((prazo) => {
                return {
                  value: parseInt(prazo.prazo),
                  label: `${prazo.prazo} dias úteis`,
                }
              }),
              impressoes: data[0].impressoes.map((impressao) => {
                return {
                  value: parseInt(impressao.qtd_batida),
                  label: `${impressao.qtd_batida} impressões`,
                }
              }),
              personalizacao: data[0].personalizacao.map((personalizacao) => {
                return {
                  value: parseInt(personalizacao.id_personalizacao),
                  label: personalizacao.nome_personalizacao,
                }
              }),
              cores: data[0].cores.map((cor) => {
                return {
                  ...cor,
                  value: parseInt(cor.codigo_cor),
                  label: cor.descricao_cor,
                  hex: cor.rgb_cores,
                }
              }),
            },
          ],
        }
      })

      toast({
        title: 'Item duplicado com sucesso!',
        status: 'success',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao duplicar item',
        status: 'error',
      })
    },
  })

  const { mutateAsync: handleDeleteItem, isLoading: deleteLoading } = useMutation({
    mutationFn: () => deleteItem({ item }),
    onSuccess: (data) => {
      queryClient.setQueryData(['items', numProposta], (old) => {
        return {
          ...old,
          itens: old.itens.filter((i) => i.id !== item.id),
          informacao_da_proposta: {
            ...old.informacao_da_proposta,
            calc_kangu: data.calc_kangu,
            comissao_prevista: data.comissao_prevista,
          },
        }
      })

      toast({
        title: 'Item deletado com sucesso!',
        status: 'success',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao deletar item',
        status: 'error',
      })
    },
  })

  async function handleAddProduct() {
    if (duplicateLoading) return
    await handleDuplicateItem({ item })
  }

  async function handleSolitarCaricatura() {
    if (solicitarCaricaturaLoading) return
    await solicitarCaricatura({
      nome_produto: item.nome_produto,
      quantidade_produto: item.quantidade,
      prazo_producao: item.prazo,
      vendedor: nome_vendedor,
      numero_nota: item.numero_nota,
      codigo_vendedor: codigo_vendedor,
      codigo_produto: item.codigo_produto,
      sequencia: item.sequencia,
      nome_cliente: cliente.razao_social,
      codigo_parceiro: cliente.codigo_parceiro,
      numero_pedido: num_proposta,
    })
  }

  return (
    <AccordionItem pointerEvents={item?.negociacao || pedidoBloqueado ? 'none' : 'auto'} border="1px solid #CFCFCF" mt={index !== 1 && 4}>
      <Box p={0}>
        <Flex flexDir="column" w="full" alignItems="flex-start">
          <Flex alignItems="center" w="full" justifyContent="space-between" borderBottom="1px solid #CFCFCF">
            <Flex alignItems="center" px="23px" py="9px" fontWeight="semibold" fontSize="15px" gap={2}>
              <Text as="span" color="#378BBF">
                Item {index}
              </Text>
              <Text color="#2D2D2D" as="span">
                | {item.nome_produto} | {item.codigo_produto}
              </Text>
              {!!item.link_layout && (
                <Text as="a" textDecor="underline" color="#378BBF" href={item.link_layout} target="_blank" rel="noreferrer" pointerEvents="auto">
                  Ver Layout
                </Text>
              )}
              {item.trava_item && (
                <Badge colorScheme="orange" variant="solid">
                  O Item precisa ser Editado.
                </Badge>
              )}
            </Flex>
            {/* {item?.caricatura && (
              <Button size="sm" bgColor="#378BBF" onClick={handleSolitarCaricatura} isLoading={solicitarCaricaturaLoading}>
                Solicitar Ilustração
              </Button>
            )} */}
            <Flex alignItems="center" justifyContent="space-between" px="23px" py="9px" maxW="300px" w="full" ml="auto">
              <ButtonToggleOrcamento item={item} numProposta={numProposta} />

              <Flex alignItems="center" gap={4} as="button">
                {!deleteLoading ? (
                  <Icon as={FaRegTrashAlt} cursor="pointer" fontSize="26px" color="#378BBF" border="1px solid #378BBF" p="3px" onClick={onOpen} />
                ) : (
                  <Flex alignItems="center" gap={4}>
                    <Spinner size="sm" color="#378BBF" />
                  </Flex>
                )}

                <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                  <AlertDialogOverlay>
                    <AlertDialogContent>
                      <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Excluir Item
                      </AlertDialogHeader>

                      <AlertDialogBody>Tem certeza que deseja excluir este item?</AlertDialogBody>

                      <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={onClose} colorScheme="gray">
                          Não
                        </Button>
                        <Button
                          colorScheme="red"
                          onClick={() => {
                            handleDeleteItem(item)
                            onClose()
                          }}
                          ml={3}
                          isLoading={deleteLoading}
                        >
                          Sim
                        </Button>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialogOverlay>
                </AlertDialog>

                <Flex
                  alignItems="center"
                  gap={2}
                  color="#378BBF"
                  border="1px solid #378BBF"
                  px="10px"
                  py="2px"
                  cursor="pointer"
                  onClick={handleAddProduct}
                >
                  {!duplicateLoading ? <Icon as={FaRegNewspaper} cursor="pointer" fontSize="20px" /> : <Spinner size="sm" color="#378BBF" />}
                  <u>{!duplicateLoading ? 'Duplicar' : 'Duplicando'}</u>
                </Flex>

                <AccordionButton p={0} onClick={() => onToggle()} pointerEvents="auto">
                  <Icon
                    as={IoIosArrowDown}
                    onClick={() => setCollapse(!collapse)}
                    cursor="pointer"
                    fontSize="20px"
                    color="#378BBF"
                    transition="transform 0.3s"
                    transform={collapse ? 'rotate(180deg)' : 'rotate(0)'}
                  />
                </AccordionButton>
              </Flex>
            </Flex>
          </Flex>

          <CollapseItem isExpanded={isExpanded} item={item} />
        </Flex>
      </Box>

      <ExpandedItem
        item={item}
        num_proposta={num_proposta}
        nome_vendedor={nome_vendedor}
        cliente={cliente}
        email_parceiro={email_parceiro}
        telefone_parceiro={telefone_parceiro}
        codigo_vendedor={codigo_vendedor}
        nome_parceiro={nome_parceiro}
      />
    </AccordionItem>
  )
}

function ButtonToggleOrcamento({ item, numProposta }) {
  async function updateShowOrcamento({ codigo_produto, numero_nota, sequencia, exibe_proposta }) {
    const response = await api.put('/site/v2/orcamento-crm/exibicao-cliente', {
      codigo_produto,
      numero_nota,
      sequencia,
      exibe_proposta,
    })

    return response.data
  }

  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
    duration: 2000,
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: () =>
      updateShowOrcamento({
        codigo_produto: item.codigo_produto,
        numero_nota: item.numero_nota,
        sequencia: item.sequencia,
        exibe_proposta: item.exibicao_proposta === 'S' ? 'N' : 'S',
      }),
    onSuccess: (data) => {
      queryClient.setQueryData(['items', numProposta], (oldData) => {
        return {
          ...oldData,
          itens: oldData.itens.map((i) => {
            if (i.sequencia === item.sequencia && i.codigo_produto === item.codigo_produto) {
              return {
                ...i,
                exibicao_proposta: data.exibe_proposta,
              }
            } else {
              return i
            }
          }),
        }
      })

      toast({
        title: 'Exibição da proposta alterada com sucesso!',
        status: 'success',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao alterar exibição da proposta',
        status: 'error',
      })
    },
  })

  async function handleShowOrcamento() {
    if (isLoading) return
    await mutateAsync()
  }

  return (
    <Flex alignItems="center" gap={2} color="#378BBF" px="10px" py="2px" cursor="pointer" onClick={handleShowOrcamento}>
      {isLoading && <Spinner size="sm" color="#378BBF" />}
      {!isLoading && (
        <Icon
          as={item.exibicao_proposta === 'S' ? FaEye : FaEyeSlash}
          color={item.exibicao_proposta === 'S' ? '#378BBF' : '#FF0000'}
          cursor="pointer"
          fontSize="20px"
        />
      )}
    </Flex>
  )
}

export const Item = memo(
  ItemComponent,
  //toda vez q muda o isExpanded, ele renderiza o componente e toda vez q muda
  (prevProps, nextProps) => {
    if (prevProps.isExpanded !== nextProps.isExpanded || JSON.stringify(prevProps.item) !== JSON.stringify(nextProps.item)) {
      return false
    }

    return true
  }
)
